/* eslint-disable import/no-cycle */
import { FunctionMapping } from '../types';
import CheckboxField from './CheckboxField';
import ColorField from './ColorField';
import ColorAlphaField from './ColorAlphaField';
import Fallback from './Fallback';
import Fieldset from './Fieldset';
import NumberField from './NumberField';
import IntegerField from './IntegerField';
import SelectField from './SelectField';
import TextField from './TextField';
import ImageField from './ImageField';
import MultiSelectField from './MultiSelectField';
import Tabset from './Tabset';
import Row from './Row';
import FileField from './FileField';
import Array from './Array';

const mapping: FunctionMapping = {
  Fieldset,
  TextField,
  NumberField,
  IntegerField,
  CheckboxField,
  ColorField,
  ColorAlphaField,
  SelectField,
  MultiSelectField,
  ImageField,
  FileField,
  Tabset,
  Row,
  Array,
  Fallback,
} as const;

export default mapping;
